import * as actions from './actions'
import * as getters from './getters'
import * as types from './types'

const state = {
  protocol: '' // 获取到的协议
}
const mutations = {
  [types.SET_PROTOCOL] (state, data) {
    state.protocol = data
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
